import { FormControl, FormLabel, TextField } from '@mui/material';
import { eachDeep } from 'deepdash-es/standalone';
import { cloneDeep, debounce } from 'lodash';
import React, { useCallback, useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { ParentScreenCtx } from "/src/pages/workbench_build/WorkbenchBuild";
import { treeActions } from '../../redux/slices/treeSlice';

const VariableDescription = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const parentScreen = useContext(ParentScreenCtx);
    const { rightTree } = useSelector((state) => state.treeData[parentScreen]);
    const translatedData = rightTree.tree[rightTree.currentTab].translatedData;
    const selectedNode = useSelector((state) => state.treeData[parentScreen].rightTree.tree.body.selectedNode);
    const [VariableDescription, setVariableDescription] = useState('');

    const submitChange = (key, val) => {
        if (key !== "DESCRIPTION") return;
        const updatedData = eachDeep(cloneDeep(translatedData), (objValue) => {
            if (objValue?.key !== selectedNode.key) {
                return;
            }
            if (key === 'DESCRIPTION') {
                objValue[key] = val;
            }
            dispatch(
                treeActions.setRightTreeSelectedNode({
                    screen: parentScreen,
                    type: rightTree.currentTab,
                    data: objValue,
                })
            );
        });
        dispatch(
            treeActions.setNewRightTreeTranslatedData({
                screen: parentScreen,
                type: rightTree.currentTab,
                data: updatedData,
            })
        );
    };

    const debounceChangeHandler = useCallback(debounce(submitChange, 500), [
        rightTree.currentTab,
        rightTree.tree,
    ]);

    useEffect(() => {
        if (selectedNode && selectedNode?.DESCRIPTION) setVariableDescription(selectedNode?.DESCRIPTION);
    }, [selectedNode.key])

    return (
        <div className="height-100 padding-12">
            <div className={"height-100"}>
                <div>
                    <FormControl
                        className="width-100"
                        size="small"
                    >
                        <FormLabel style={{fontWeight:'bold'}}>{`${(selectedNode?.NAME || "")} ${t("LBL_DESC")}`}</FormLabel>
                        <TextField
                            className="text-field-scroll width-100"
                            autoFocus={true}
                            multiline={true}
                            rows={10}
                            size="medium"
                            type="text"
                            value={VariableDescription}
                            onChange={(e) => {
                                setVariableDescription(e.target.value);
                                debounceChangeHandler('DESCRIPTION', e.target.value);
                            }}
                        />
                    </FormControl>
                </div>
            </div>
        </div>
    )
}

export default VariableDescription